import React, { useEffect, useState } from 'react';
import { GetAllProductAttributesWithValues } from '../../Services/AttributeService';

const GrindingTexture = ({ onSelectionChange, selectedProducts }) => { // selectedProducts ab use nahi ho raha
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load initial state from localStorage
  const [selectedGrinding, setSelectedGrinding] = useState(() => {
    const saved = localStorage.getItem('customise-grindingSelection');
    try {
      return saved ? JSON.parse(saved).grinding : null;
    } catch (e) { return null; }
  });
  const [selectedPackaging, setSelectedPackaging] = useState(() => {
    const saved = localStorage.getItem('customise-grindingSelection');
    try {
      return saved ? JSON.parse(saved).packaging : null;
    } catch (e) { return null; }
  });

  useEffect(() => {
    fetchAttributes();
  }, []); // Run only once on mount

  useEffect(() => {
    // Auto-select first item if nothing is selected
    if (attributes.length > 0 && !selectedGrinding && !selectedPackaging) {
      const grindingTexture = attributes.find(attr =>
        attr.name?.toLowerCase().includes('grinding') || attr.id === 5
      );

      const packaging = attributes.find(attr =>
        attr.name?.toLowerCase().includes('packaging') || attr.id === 6
      );

      // Select first grinding texture option
      if (grindingTexture && grindingTexture.values && grindingTexture.values.length > 0) {
        const firstGrinding = grindingTexture.values[0];
        const firstPrice = (firstGrinding.increasePrice && firstGrinding.increasePrice !== "0" && firstGrinding.increasePrice !== 0)
          ? firstGrinding.increasePrice
          : (firstGrinding.name?.toLowerCase().includes("cold press") ? 20 : (firstGrinding.name?.toLowerCase().includes("pisai") ? 5 : 0));

        setSelectedGrinding({
          id: firstGrinding.id,
          name: firstGrinding.name,
          increasePrice: firstPrice
        });
      }

      // Select first packaging option
      if (packaging && packaging.values && packaging.values.length > 0) {
        const firstPackaging = packaging.values[0];
        setSelectedPackaging({
          id: firstPackaging.id,
          name: firstPackaging.name,
          increasePrice: firstPackaging.increasePrice || 0
        });
      }
    }
  }, [attributes, selectedGrinding, selectedPackaging]);

  useEffect(() => {
    // Notify parent component about selection changes
    if (onSelectionChange) {
      onSelectionChange(selectedGrinding, selectedPackaging);
    }

    // Save to localStorage whenever selections change
    // (Parent 'handleGrindingSelectionChange' bhi save karta hai, but yeh redundant/safe hai)
    if (selectedGrinding || selectedPackaging) {
      localStorage.setItem('customise-grindingSelection', JSON.stringify({
        grinding: selectedGrinding,
        packaging: selectedPackaging
      }));
    }

  }, [selectedGrinding, selectedPackaging, onSelectionChange]);

  const fetchAttributes = async () => {
    setLoading(true);
    setError(null);

    try {
      // Get wheat product ID from localStorage
      const wheatProductId = localStorage.getItem('customise-wheatProductId');

      if (!wheatProductId) {
        console.warn('No wheat product ID found in localStorage');
        setLoading(false);
        setAttributes([]); // Ensure attributes are empty
        return;
      }

      // Call API with productIds for the selected wheat product to get its attributes
      const response = await GetAllProductAttributesWithValues({
        productId: [parseInt(wheatProductId, 10)], // Use the ID from storage
        attributeIds: [5, 6] // Grinding Texture and Packaging
      });

      setAttributes(response.data || []);
    } catch (error) {
      setError(error.message || 'Failed to fetch attributes');
    } finally {
      setLoading(false);
    }
  };

  const handleGrindingChange = (valueId, valueName, increasePrice) => {
    setSelectedGrinding({
      id: valueId,
      name: valueName,
      increasePrice: increasePrice || 0
    });
  };

  const handlePackagingChange = (valueId, valueName, increasePrice) => {
    setSelectedPackaging({
      id: valueId,
      name: valueName,
      increasePrice: increasePrice || 0
    });
  };

  // Find Grinding Texture and Packaging attributes
  const grindingTexture = attributes.find(attr =>
    attr.name?.toLowerCase().includes('grinding') || attr.id === 5
  );

  const packaging = attributes.find(attr =>
    attr.name?.toLowerCase().includes('packaging') || attr.id === 6
  );

  return (
    <div>
      <div className="section-title">
        <h5>Select Grinding Texture</h5>
        <p>Select from our Grinding Texture to start your custom flour mix.</p>
      </div>

      <div className={'content-box'}>
        {loading ? (
          <p className="text-center">Loading options...</p>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <div className="choose-your-grinding">
            {/* Grinding Texture Section */}
            {grindingTexture && grindingTexture.values && grindingTexture.values.length > 0 && (
              <div className="row">
                <div className="col-12">
                  <h5 className={'fs_24 fw_700 lh-2 mb_20 title text-capitalize'}>
                    {grindingTexture.name || 'Choose Grinding Texture'}
                  </h5>
                </div>
                {grindingTexture.values.map((value) => {
                  const price = (value.increasePrice && value.increasePrice !== "0" && value.increasePrice !== 0)
                    ? value.increasePrice
                    : (value.name?.toLowerCase().includes("cold press") ? 20 : (value.name?.toLowerCase().includes("pisai") ? 5 : 0));

                  return (
                    <div className="col-lg-4" key={value.id}>
                      <div className="form-check custom-radio">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="grindingTexture"
                          id={`grinding-${value.id}`}
                          checked={selectedGrinding?.id === value.id}
                          onChange={() => handleGrindingChange(value.id, value.name, price)}
                        />
                        <label className="form-check-label" htmlFor={`grinding-${value.id}`}>
                          {value.name}
                          {price > 0 && ` (+${price} ₹)`}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Packaging Section */}
            {packaging && packaging.values && packaging.values.length > 0 && (
              <div className="row">
                <div className="col-12">
                  <h5 className={'fs_24 fw_700 lh-2 mb_20 mt-xl-5 text-color text-capitalize'}>
                    {packaging.name || 'Choose Packaging'}
                  </h5>
                </div>
                {packaging.values.map((value) => (
                  <div className="col-lg-4" key={value.id}>
                    <div className="form-check custom-radio">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="packaging"
                        id={`packaging-${value.id}`}
                        checked={selectedPackaging?.id === value.id}
                        onChange={() => handlePackagingChange(value.id, value.name, value.increasePrice)}
                      />
                      <label className="form-check-label" htmlFor={`packaging-${value.id}`}>
                        {value.name}
                        {value.increasePrice && value.increasePrice !== "0" && ` (+${value.increasePrice} ₹)`}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Show message if no options are found */}
            {(!grindingTexture || !grindingTexture.values || grindingTexture.values.length === 0) &&
              (!packaging || !packaging.values || packaging.values.length === 0) &&
              !loading && (
                <p className="text-center text-muted">No grinding or packaging options available for the selected wheat product.</p>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GrindingTexture;